import request from "@/utils/request";
// 收货地址
export function getaddres(){
    return request({
      url: '/mall/mallmanage/demandOrder/queryReceivingAddr',
      method: "POST",
    });
  }

// 校验购物车里的商品存在直销供方的商品
export function settlementShoppingCart(){
  return request({
    url: '/mall/mallmanage/demandOrder/settlementShoppingCart',
    method: "POST",
  });
}